module.exports = __webpack_public_path__ + "img/homBanner.9f324e45.jpg";